<template>
	<div class="c-checklist-block__content">
		<slot name="checklist-block-items" />
	</div>
</template>

<script>
export default {
	name: "VChecklistBlock"
};
</script>
